

class Navigation {
    constructor(element) {
        this.isOpen = false;
        this.element = element;

        this.closeAllSubNavs = this.closeAllSubNavs.bind(this);
        
        this.init = this.init.bind(this);
        this.init();  
    }
    
    
    init() {         
        var closeNavButton = document.querySelectorAll(".navigation__back");
        var expandCheckbox = document.querySelectorAll(".expand-check");

        expandCheckbox.forEach(box => {
            box.addEventListener('change', event => {
               if( box.checked ) {
                    this.closeAllSubNavs();
                    box.checked = true;
               } else {
                    
                    box.checked = false;
               }   
            })
        });

        closeNavButton.forEach(link => {
            link.addEventListener('click', event => {
                this.closeAllSubNavs();
            })
        });


    }

    closeAllSubNavs()  {
        this.element.querySelectorAll('.expand-check').forEach(nav => {
            nav.checked = false
        });
    }
}

export default Navigation;